











export default {
  name: 'domain',
  props: {
    loading: Object
  }
};

